import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../helpers/api/apiCall";

const initialState = {
  esmaulHusnalar: {
    items: [],
    index: 0,
    size: 10,
    count: 0,
    pages: 0,
    hasPrevious: false,
    hasNext: false,
  },
  loading: true,
};

export const getEsmaulHusnalar = createAsyncThunk("getEsmaulHusnalar", async (body) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/EsmaulHusna/GetList",body);
  return response.data;
});

export const insertEsmaulHusna = createAsyncThunk("insertEsmaulHusna", async (body,thunkAPI) => {
  const response = await client.post("https://servis.kuranhayatim.com/api/EsmaulHusna", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const updateEsmaulHusna = createAsyncThunk("updateEsmaulHusna", async (body,thunkAPI) => {
  const response = await client.put("https://servis.kuranhayatim.com/api/EsmaulHusna", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

export const deleteEsmaulHusna = createAsyncThunk("deleteEsmaulHusna", async (body,thunkAPI) => {
  const response = await client.delete("https://servis.kuranhayatim.com/api/EsmaulHusna", body,{
    token: thunkAPI.getState().auth.accessToken.token
  });
  return response.data;
});

const esmaulHusnaSlice = createSlice({
  name: "esmaulHusna",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getEsmaulHusnalar.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getEsmaulHusnalar.fulfilled, (state, action) => {
      state.esmaulHusnalar = action.payload;
      state.loading = false;
    });
    builder.addCase(getEsmaulHusnalar.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertEsmaulHusna.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(insertEsmaulHusna.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(insertEsmaulHusna.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateEsmaulHusna.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updateEsmaulHusna.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(updateEsmaulHusna.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteEsmaulHusna.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(deleteEsmaulHusna.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(deleteEsmaulHusna.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default esmaulHusnaSlice.reducer;
